import { DateFormat, t, Trans } from '@lingui/macro'
import { colors, Dialog, Typography } from '@material-ui/core'
import { addMonths, differenceInDays, isAfter } from 'date-fns'
import { css } from 'emotion'
import React, { useCallback, useState } from 'react'
import { EBillingPlan, IAccount } from 'shopify-payment-core'

import { AccountBillingAdmin } from '../bricks/AccountBillingAdmin'
import { useAccountUpdate } from '../hooks/useAccountUpdate'
import { i18n } from '../i18n'
import { SmallButton } from './SmallButton'

interface IProps {
  account: IAccount
}

const okStatus = css`
  color: ${colors.green[400]} !important;
`

const dueSoonStatus = css`
  color: ${colors.orange[500]} !important;
`

const dueOverStatus = css`
  color: ${colors.red[700]} !important;
`

export const AccountInvoiceCell: React.FC<IProps> = ({ account }) => {
  const [dialogOpen, setOpen] = useState(false)
  const update = useAccountUpdate(account, '')

  const markPaid = useCallback(
    () => {
      const nextDueDate =
        account.billingPlan === EBillingPlan.MONTHLY
          ? addMonths(account.invoiceDueDate || new Date(), 1).toISOString()
          : account.invoiceDueDate || null
      update(
        {
          invoicePaidAt: new Date().toISOString(),
          invoiceDueDate: nextDueDate,
        },
        i18n._(t`Faktura byla zaplacena`),
      )
    },
    [account],
  )

  const { invoiceDueDate, invoicePaidAt } = account

  if (account.billingPlan === EBillingPlan.ONETIME && invoicePaidAt) {
    return (
      <Typography className={okStatus} variant="body2">
        <Trans>
          Zaplaceno <DateFormat value={new Date(invoicePaidAt!)} />
        </Trans>
      </Typography>
    )
  }

  // Not working properly, upon click in the dialog it gets redirected to account detail instead
  if (!invoiceDueDate) {
    return (
      <>
        <Typography variant="body2">
          <SmallButton
            onClick={ev => {
              setOpen(true)
              ev.stopPropagation()
            }}
          >
            <Trans>Nastavit</Trans>
          </SmallButton>
        </Typography>
        <Dialog
          fullWidth
          open={dialogOpen}
          onClose={ev => {
            setOpen(false)
          }}
        >
          <AccountBillingAdmin account={account} noGutter={true} />
        </Dialog>
      </>
    )
  }

  let status = okStatus
  if (isAfter(new Date(), invoiceDueDate)) {
    status = dueOverStatus
  } else if (differenceInDays(invoiceDueDate, new Date()) < 7) {
    status = dueSoonStatus
  }

  return (
    <Typography variant="body2" className={status}>
      <Trans>
        do <DateFormat value={new Date(invoiceDueDate!)} />
      </Trans>
      <SmallButton onClickCapture={markPaid}>
        <Trans>Zaplatit</Trans>
      </SmallButton>
    </Typography>
  )
}
